module.exports = __webpack_public_path__ + "static/media/b2.77c49338.png";